<template>

</template>

<script>
	export default {
		name: 'BaseVariables',
		props: {
			dataAvailableSites: {
				type: Array,
				required: false
			},
			dataSelectedSite: {
				type: Object,
				required: false
			},
			dataAvailableLanguages: {
				type: Array,
				required: false
			},
			dataDefaultLanguage: {
				type: Object,
				required: false
			},
			dataCurrentUser: {
				type: Object,
				required: false
			},
			dataCurrentUserRoles: {
				type: Array,
				required: false
			}
		},
		data() {
			return {
				availableSites: this.dataAvailableSites ? this.dataAvailableSites : {},
				selectedSite: this.dataSelectedSite ? this.dataSelectedSite : {},
				availableLanguages: this.dataAvailableLanguages ? this.dataAvailableLanguages : [],
				defaultLanguage: this.dataDefaultLanguage ? this.dataDefaultLanguage : {},
				currentUser: this.dataCurrentUser ? this.dataCurrentUser : {},
				currentUserRoles: this.dataCurrentUserRoles ? this.dataCurrentUserRoles : {},
			}
		},
		created() {
			Vue.prototype.$availableSites = this.availableSites;
			Vue.prototype.$selectedSite = this.selectedSite;
			Vue.prototype.$availableLanguages = this.availableLanguages;
			Vue.prototype.$defaultLanguage = this.defaultLanguage;
			Vue.prototype.$currentUser = this.currentUser;
			Vue.prototype.$currentUserRoles = this.currentUserRoles;

			Vue.prototype.$tinyMCEApiKey = '4o3sm1to0f101t0ywgtbe0j39xi0f93r8e3b6h10x2ayown4';
			Vue.prototype.$tinyMCEConfig = {
				plugins: [
					'advlist autolink autoresize lists link image charmap',
					'print preview anchor searchreplace visualblocks code',
					'fullscreen insertdatetime media table paste help wordcount paste'
				],
				toolbar:
						'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright | ' +
						'bullist numlist outdent indent | image | removeformat | code | help',
				toolbar_sticky: true,
				contextmenu: 'paste | link image',
				relative_urls: false,
				remove_script_host: false,
				convert_urls: false,
				images_upload_url: '/api/' + this.selectedSite.slug + '/articles/upload/contentImage',
				image_title: true,
				automatic_uploads: true,
				images_reuse_filename: true,
				image_prepend_url: 'https://cdn.proprivacy.com/',
				paste_word_valid_elements: 'h2,h3,h4,h5,h6,p,ul,ol,li,a,strong,em,img',
				paste_as_text: true,
				paste_enable_default_filters: false,
				paste_data_images: true,
				paste_auto_cleanup_on_paste: true,
				paste_preprocess: function (plugin, args) {
					// remove html comments
					args.content = args.content.replace(/(?=<!--)([\s\S]*?)-->/g, '');
					// remove all <!-- [if. .endif]-->
					args.content = args.content.replace(/<!\[([\s\S]*?)endif\]>/g, "");
					// remove all empty paragraphs
					args.content = args.content.replace(/<p[^>]*>(<br[^>]*>)*(\s|& nbsp;|\r|\n)*(<br[^>]*>)*(\s|& nbsp;|\r|\n)*<\/p>/g, "");
					// remove all white space before closing tag
					args.content = args.content.replace(/\s+<\//g, "</");
					args.content = args.content.replace('<br />', '');
				},
				paste_postprocess: function (plugin, args) {
					if (args.wordContent) {
						// remove everything in between and including tags '<style(.)style(.)>'
						var badTagsAttributes = ['class', 'style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'lang', 'xml:lang', 'role', 'paraid', 'name', 'aria-([\\s\\S]*?)', 'data-([\\s\\S]*?)', 'start', 'type'];
						for (var i = 0; i < badTagsAttributes.length; i++) {
							var attributeStripper = new RegExp(badTagsAttributes[i] + '="([\\s\\S]*?)"', 'mgiu');
							args.node.innerHTML = args.node.innerHTML.replace(attributeStripper, '');
						} // for


						// remove everything starting and closing tags, leave what is between
						var badTags = ['span', 'div'];
						for (var i = 0; i < badTags.length; i++) {
							var tagStripper = new RegExp('<\/?' + badTags[i] + '([\\s\\S]*?)>', 'gi');
							args.node.innerHTML = args.node.innerHTML.replace(tagStripper, '');
						} // for
					} // if
					// remove all empty paragraph
					args.node.innerHTML = args.node.innerHTML.replace(/<p>&nbsp;<\/p>/g, '');
					args.node.innerHTML = args.node.innerHTML.replace(/<div>&nbsp;<\/div>/g, '');
				}
			};
		}
	}
</script>

<style scoped>

</style>
